import { Stack, FlexboxGrid, Col } from 'rsuite';
import classNames from 'classnames';
import MenuIcon from '@rsuite/icons/Menu';
import { HomeElms, host, server } from '../config/const';
import { useAppSelector, useAppDispatch } from '@monorepo/shared';
import {
  Brand,
  OUTree,
  NoticeSpeaker,
  UserProfile,
  ServicesDrawer,
  SupportDrawer,
  LocaleSelector,
  ServiceDropdown,
  SupportDropdown
} from '@monorepo/shared/components';
import ServiceImg from '../images/header/service.svg';
import supportImg from '../images/header/support.svg';
import { cloudLog } from '../pages/Home/homeCons';
import {
  useGetCommonDataQuery,
  useGetSystemDataQuery
} from '@monorepo/shared/services/globalApi';
import {
  isExpanded,
  updateExpanded
} from '@monorepo/shared/store/sidemenuSlice';
import { useLocation } from 'react-router-dom';
import { CSSProperties } from 'react';
import {
  selectNotices,
  selectPermission
} from '@monorepo/shared/store/authSlice';
import {
  selectCurrentAccount,
  selectLoginAccount
} from '@monorepo/shared/store/accountSlice';
import { selectOU } from '@monorepo/shared/store/fcOuSlice';
interface IProps {
  hideSideMenu?: boolean;
  style?: CSSProperties;
}

const Header = ({ hideSideMenu, style }: IProps) => {
  const userPermission = useAppSelector(selectPermission);
  const { pathname } = useLocation();
  const loginAccount = useAppSelector(selectLoginAccount);
  const ouData = useAppSelector(selectOU);
  const notices = useAppSelector(selectNotices);
  const currentAccount = useAppSelector(selectCurrentAccount);
  const commonData = useGetCommonDataQuery(
    { server: server },
    {
      skip: userPermission === 'unset'
    }
  );
  const { data: systemData } = useGetSystemDataQuery(
    { server: server },
    {
      skip: userPermission === 'unset'
    }
  );
  const menuExpanded = useAppSelector(isExpanded);
  const logoIcon = (
    <img
      src={cloudLog}
      width="40px"
      style={{ filter: 'invert(1)', marginRight: '8px' }}
    ></img>
  );
  const logoClasses = classNames('left-container', {
    expand: menuExpanded
  });
  const dispatch = useAppDispatch();

  return (
    <FlexboxGrid className="frame-header" justify="space-between" style={style}>
      <FlexboxGrid.Item className={logoClasses}>
        <Stack
          alignItems="center"
          style={{ height: '100%', marginLeft: '40px' }}
          spacing={60}
        >
          {/* {!hideSideMenu && (
            <MenuIcon
              onClick={() => dispatch(updateExpanded(!menuExpanded))}
              style={{ cursor: 'pointer' }}
            />
          )} */}
          <Brand
            // link={`/organization`}
            logo={logoIcon}
            title={HomeElms.name}
            subtitle={'Cloud'}
            titleStyle={{
              fontWight: 'blod',
              fontSize: '1.2rem',
              color: '#212121'
            }}
            subTitleStyle={{
              fontWight: 'blod',
              fontSize: '1.2rem',
              paddingLeft: '8px',
              color: '#212121'
            }}
          />
          <ServiceDropdown
            commonData={commonData?.data}
            account={currentAccount}
          />
          <SupportDropdown
            commonData={commonData?.data}
            account={currentAccount}
          />
        </Stack>
      </FlexboxGrid.Item>
      <FlexboxGrid.Item
        as={Col}
        md={4}
        ms={4}
        xs={4}
        className="right-container"
      >
        <Stack
          spacing={20}
          justifyContent="flex-end"
          style={{ height: '100%' }}
        >
          {systemData?.i18n_support && (
            <Stack.Item style={{ width: '140px' }}>
              <LocaleSelector host={host} />
            </Stack.Item>
          )}
          <NoticeSpeaker notices={notices} />
          {!pathname.includes('cred') && ouData?.length ? <OUTree /> : <></>}
          <UserProfile
            account={
              currentAccount?.user_display_info?.length
                ? currentAccount
                : loginAccount
            }
            facEmail={loginAccount?.fac_email}
            commonData={commonData?.data}
            isNewPortal={true}
          />
        </Stack>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default Header;
